import Intro from "../Sections/Intro/Intro";
import About from "../Sections/About/About";
import Skills from "../Sections/Skills/Skills";
import Contacts from "../Sections/Contacts/Contacts";
import Stages from "../Sections/Stages/Stages";
import Work from "../Sections/Work/Work";

const MainPage = () => {
  return (
    <>
      <Intro />
      <About />
      <Skills />
      <Stages />
      <Work />
      <Contacts />
    </>
  );
};


export default MainPage;